// Admin do canal ScontiPoste
const adminChannelDictIT = {
  adminChannelMenu: "ScontiPoste",
  adminChannelTabConfig: "Configurazione",
  adminChannelTabSellers: "Manager",
  adminChannelTabSales: "Vendite",
  adminChannelTabCashback: "Accantonamento cashback",
  adminChannelUrl: "Link della vetrina",
  adminChannelUrlHelp: "È il link che ScontiPoste pubblica. Per sapere da dove arrivano le vendite, usa il link con le UTM.",
  adminChannelUtmUrl: "Link con UTM",
  adminChannelOpen: "Apri la vetrina",
  adminChannelStatus: "Stato",
  adminChannelActive: "Vetrina aperta al pubblico",
  adminChannelInactive: "Vetrina chiusa",
  adminChannelPercent: "Cashback ScontiPoste (%)",
  adminChannelPercentHelp: "Trattenuto al venditore su ogni vendita. Vale solo per i nuovi ordini.",
  adminChannelSave: "Salva",
  adminChannelSaved: "Configurazione salvata",
  adminChannelActiveSellers: "Manager attivi: {count}",
  adminChannelOutdated: "{count} Manager non hanno ancora accettato la % attuale: i loro prodotti sono fuori dalla vetrina.",
  adminChannelConfirmPercentTitle: "Cambiare il cashback?",
  adminChannelConfirmPercent: "Il cashback passa dal {from}% al {to}%. I {count} Manager attivi devono accettare la nuova % nel loro pannello; fino ad allora i loro prodotti escono dalla vetrina.",
  adminChannelConfirmPercentAction: "Passa al {to}%",
  adminChannelSeller: "Manager",
  adminChannelJoined: "Adesione",
  adminChannelTermsPercent: "% accettata",
  adminChannelProductsMode: "Prodotti",
  adminChannelAllProducts: "Tutto il negozio",
  adminChannelSelectedProducts: "Selezionati",
  adminChannelListed: "In vetrina",
  adminChannelSellerStatus: "Stato",
  adminChannelStatusActive: "Attivo",
  adminChannelStatusOutdated: "Accettazione in sospeso",
  adminChannelStatusLeft: "Fuori dal canale",
  adminChannelSuspend: "Sospendi",
  adminChannelReactivate: "Riattiva",
  adminChannelSuspendTitle: "Sospendere il Manager?",
  adminChannelSuspendConfirm: "I prodotti di {name} escono subito dalla vetrina ScontiPoste. Gli ordini già fatti proseguono normalmente.",
  adminChannelSearchSellers: "Cerca Manager",
  adminChannelFrom: "Dal",
  adminChannelTo: "Al",
  adminChannelApply: "Filtra",
  adminChannelCheckout: "Checkout",
  adminChannelDate: "Data",
  adminChannelBuyer: "Acquirente",
  adminChannelOrders: "Ordini",
  adminChannelTotal: "Totale",
  adminChannelOrigin: "Origine",
  adminChannelNoOrigin: "Senza UTM",
  adminChannelCheckoutPAID: "Pagato",
  adminChannelCheckoutCREATED: "Non completato",
  adminChannelCheckoutFAILED: "Non riuscito",
  adminChannelCheckoutREFUNDED: "Rimborsato",
  adminChannelCheckoutPARTIALLY_REFUNDED: "Rimborso parziale",
  adminChannelPaidTotal: "Totale pagato nel periodo: {total}",
  adminChannelSearchSales: "Cerca acquirente, ordine o campagna",
  adminChannelCashbackHelp: "Cashback trattenuto ai venditori alla ricezione degli ordini. Serve per controllare la fattura di Poste Italiane.",
  adminChannelCashbackTotal: "Totale accantonato nel periodo: {total}",
  adminChannelExportCsv: "Esporta CSV",
  adminChannelBySeller: "Per Manager",
  adminChannelOrder: "Ordine",
  adminChannelAmount: "Importo",
  adminChannelOrderAmount: "Valore dei prodotti",
  adminChannelSearchCashback: "Cerca Manager o ordine",
  adminChannelEntryACCRUED: "Accantonato",
  adminChannelEntryREVERSED: "Stornato",
  channelError500439: "Il cashback deve essere tra 0 e 100, con al massimo 2 decimali.",
  channelError500440: "Imposta un cashback maggiore di 0 prima di aprire la vetrina.",
};

export default adminChannelDictIT;
